module.exports = __webpack_public_path__ + "img/img_jobs-careers.cf81268b.png";